var map = {
	"./soil.svg": 977,
	"./tree-step-1.svg": 436,
	"./tree-step-2_1.svg": 437,
	"./tree-step-2_2.svg": 438,
	"./tree-step-3_1.svg": 439,
	"./tree-step-3_2.svg": 440,
	"./tree-step-3_3.svg": 441,
	"./tree-step-4_1.svg": 442,
	"./tree-step-4_2.svg": 443,
	"./tree-step-4_3.svg": 444,
	"./tree-step-4_4.svg": 445,
	"./tree-step-5_1.svg": 446,
	"./tree-step-5_2.svg": 447,
	"./tree-step-5_3.svg": 448,
	"./tree-step-5_4.svg": 449,
	"./tree-step-5_5.svg": 450,
	"./tree-step-6_1.svg": 451,
	"./tree-step-6_2.svg": 452,
	"./tree-step-6_3.svg": 453,
	"./tree-step-6_4.svg": 293,
	"./tree-step-6_5.svg": 454,
	"./tree-step-6_6.svg": 455,
	"./tree-step.svg": 456,
	"./tree-step_soil.svg": 175,
	"./tree_1.svg": 978,
	"./tree_2.svg": 979,
	"./tree_3.svg": 980,
	"./tree_4.svg": 981,
	"./tree_5.svg": 982,
	"./tree_6.svg": 983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197;